export default [
  /**
   * 默认登录平台配置
   */
  {
    title: '精彩纵横云采购平台',
    alias: 'default', // 平台别称
    domain: process.env.VUE_APP_DOMAIN.split(','), // 匹配域名
    favicon: './favicon.ico',
    logo: require('@/assets/images/jczh/complete-logo.png'), // 网站logo
    logoHeight: 50,
    loginLogo: require('@/assets/images/jczh/complete-logo-white.png'), // 登录页面的logo
    loginBgImg: require('./assets/images/jczh/background.png'), // 登录页面背景
    needValueAdd: true, // 是否需要增值服务
    theme: ['#1890ff', '#ff4d4f'], // 主题颜色 （涉及Element）
    otherTheme: ['#1890ff', '#a7d5ff', '#d8ebff', '#edf6ff', '#f8f9fb'], // 主题衍生色 （不涉及element-ui）
    defaultLoginMethod: 'wechat', // 默认登录方式
    loginUrl: process.env.VUE_APP_LOGIN_URL,
    portalUrl: process.env.VUE_APP_PORTAL_URL
  },

  /**
   * 国资登录平台配置
   */
  {
    title: '江西省国有企业采购交易服务平台',
    alias: 'gz',
    domain: process.env.VUE_APP_GZ_DOMAIN.split(','), // 匹配域名
    favicon: './undefined-favicon.ico',
    logo: require('@/assets/images/gzw/logo.png'), // 网站logo
    logoHeight: 40,
    loginLogo: require('@/assets/images/gzw/logo-white.png'), // 登录页面的logo
    loginBgImg: require('@/assets/images/gzw/background.png'),
    loginContentPosition: 'right',
    needValueAdd: true,
    theme: ['#005CB8', '#ff4d4f'], // 主题颜色
    otherTheme: ['#005CB8', '#a7d5ff', '#d8ebff', '#edf6ff', '#f8f9fb'],
    defaultLoginMethod: 'wechat',
    loginUrl: process.env.VUE_APP_GZ_LOGIN_URL,
    portalUrl: process.env.VUE_APP_GZ_PORTAL_URL
  },

  /**
   * 新余国资委平台配置
   */
  {
    title: '新余市国有企业采购交易服务平台',
    alias: 'xygz',
    domain: process.env.VUE_APP_XYGZ_DOMAIN.split(','), // 匹配域名
    favicon: './undefined-favicon.ico',
    logo: require('@/assets/images/xygz/logo.png'), // 网站logo
    logoHeight: 40,
    loginLogo: require('@/assets/images/xygz/logo.png'), // 登录页面的logo
    loginBgImg: require('@/assets/images/xygz/background.png'),
    loginBgPosition: 'center', // 登录页面背景图片的裁切位置
    loginContactTheme: 'dark', // 登录页面联系方式的主题
    needValueAdd: false,
    theme: ['#005CB8', '#ff4d4f'], // 主题颜色
    otherTheme: ['#005CB8', '#a7d5ff', '#d8ebff', '#edf6ff', '#f8f9fb'],
    defaultLoginMethod: 'account',
    loginUrl: process.env.VUE_APP_XYGZ_LOGIN_URL,
    portalUrl: process.env.VUE_APP_XYGZ_PORTAL_URL,
    footer: {
      theme: 'dark'
    }
  },

  /**
   * 省投登录平台配置
   */
  {
    title: '江投集团电子采购平台',
    alias: 'jxic',
    domain: process.env.VUE_APP_JXIC_DOMAIN.split(','),
    favicon: './jxic-favicon.ico',
    logo: require('@/assets/images/jxic/logo.png'), // 网站logo
    logoHeight: 50,
    loginLogo: require('@/assets/images/jxic/logo-white.png'), // 登录页面的logo
    loginBgImg: require('@/assets/images/jxic/background.png'),
    needValueAdd: false,
    theme: ['#E36C09', '#ff4d4f'], // 主题颜色
    otherTheme: ['#E36C09', '#FDC494', '#FFECDB', '#FFF4EB', '#F8F8F8'],
    defaultLoginMethod: 'account',
    loginUrl: process.env.VUE_APP_JXIC_LOGIN_URL,
    portalUrl: process.env.VUE_APP_JXIC_PORTAL_URL,
    footer: {
      copyright: '江西省投资集团有限公司',
      beian: '赣ICP备17012588号-1',
      address: '江西省南昌市东湖区阳明东路66号投资大厦'
    }
  },

  /**
   * 赣江控股平台配置
   */
  {
    title: '赣江控股电子采购平台',
    alias: 'gjkg',
    domain: process.env.VUE_APP_GJKG_DOMAIN.split(','),
    favicon: './gjkg-favicon.ico',
    logo: require('@/assets/images/gjkg/logo.png'), // 网站logo
    logoHeight: 50,
    loginLogo: require('@/assets/images/gjkg/logo.png'), // 登录页面的logo
    loginBgImg: require('@/assets/images/gjkg/background.png'),
    needValueAdd: false,
    theme: ['#1890ff', '#ff4d4f'], // 主题颜色 （涉及Element）
    otherTheme: ['#1890ff', '#a7d5ff', '#d8ebff', '#edf6ff', '#f8f9fb'], // 主题衍生色 （不涉及element-ui）
    defaultLoginMethod: 'account',
    loginUrl: process.env.VUE_APP_GJKG_LOGIN_URL,
    portalUrl: process.env.VUE_APP_GJKG_PORTAL_URL,
    footer: {
      copyright: '赣江控股集团有限公司',
      beian: '赣ICP备17012588号-1',
      address: '江西省赣江新区直管区金山大道2333号'
    }
  },

  /**
   * 新钢登录平台配置
   */
  {
    title: '新钢集团数字采购平台',
    alias: 'xin-steel',
    domain: process.env.VUE_APP_XIN_STEEL_DOMAIN.split(','),
    favicon: './xin-steel-favicon.ico',
    logo: require('@/assets/images/xin-steel/logo.png'), // 网站logo
    logoHeight: 50,
    loginLogo: require('@/assets/images/xin-steel/logo.png'), // 登录页面的logo
    loginBgImg: require('@/assets/images/xin-steel/background.png'),
    needValueAdd: false,
    theme: ['#226CFD', '#ff4d4f'], // 主题颜色
    otherTheme: ['#226CFD', '#a7d5ff', '#d8ebff', '#edf6ff', '#f8f9fb'], // 主题衍生色 （不涉及element-ui）
    defaultLoginMethod: 'account',
    loginUrl: process.env.VUE_APP_XIN_STEEL_LOGIN_URL,
    portalUrl: process.env.VUE_APP_XIN_STEEL_PORTAL_URL,
    footer: {
      copyright: '新余钢铁集团有限公司',
      beian: '赣ICP备05004368号-1',
      address: '江西省新余市渝水区冶金路1号',
      links: [
        {
          name: '江西省国有企业采购交易服务平台',
          url: 'https://www.jxgqcg.com/'
        },
        { name: '江西省公共资源交易平台', url: 'https://ggzy.jiangxi.gov.cn' },
        {
          name: '中国招标投标公共服务平台',
          url: 'http://www.cebpubservice.com'
        },
        { name: '新余钢铁集团公司', url: 'https://www.xinsteel.com.cn/' }
      ]
    }
  },

  /**
   * 港口集团平台配置
   */
  {
    title: '江西省港口集团电子采购平台',
    alias: 'gkjt',
    domain: process.env.VUE_APP_GKJT_DOMAIN.split(','),
    favicon: './gkjt-favicon.ico',
    logo: require('@/assets/images/gkjt/logo.png'), // 网站logo
    logoHeight: 50,
    loginLogo: require('@/assets/images/gkjt/logo.png'), // 登录页面的logo
    loginBgImg: require('@/assets/images/gkjt/background.png'),
    loginBgPosition: 'center', // 登录页面背景图片的裁切位置
    loginContactTheme: 'dark', // 登录页面联系方式的主题
    needValueAdd: false,
    theme: ['#0062B1', '#ff4d4f'], // 主题颜色
    otherTheme: ['#0062B1', '#a7d5ff', '#d8ebff', '#edf6ff', '#f8f9fb'], // 主题衍生色 （不涉及element-ui）
    defaultLoginMethod: 'account',
    loginUrl: process.env.VUE_APP_GKJT_LOGIN_URL,
    portalUrl: process.env.VUE_APP_GKJT_PORTAL_URL,
    footer: {
      copyright: '江西省港口集团有限公司',
      beian: '赣ICP备20008756号',
      address: '江西省南昌市东湖区抚河北路249号江西交通科技大楼'
    }
  },

  /**
   * 抚州城建集团官网搭建
   */
  {
    title: '抚州市城市建设集团电子采购平台',
    alias: 'fzjjt',
    domain: process.env.VUE_APP_FZJJT_DOMAIN.split(','),
    favicon: './fzjjt-favicon.ico',
    logo: require('@/assets/images/fzjjt/logo.png'),
    logoHeight: 58,
    loginLogo: require('@/assets/images/fzjjt/logo-white.png'),
    loginBgImg: require('@/assets/images/fzjjt/background.png'),
    needValueAdd: false,
    theme: ['#1890ff', '#ff4d4f'], // 主题颜色 （涉及Element）
    otherTheme: ['#1890ff', '#a7d5ff', '#d8ebff', '#edf6ff', '#f8f9fb'], // 主题衍生色 （不涉及element-ui）
    defaultLoginMethod: 'account',
    loginUrl: process.env.VUE_APP_FZJJT_LOGIN_URL,
    portalUrl: process.env.VUE_APP_FZJJT_PORTAL_URL,
    footer: {
      copyright: '抚州市城市建设集团有限公司',
      beian: '赣ICP备18002346号-1',
      address: '江西省抚州市临川区赣东大道1322号'
    }
  },

  /**
   * 水投集团官网搭建
   */
  {
    title: '江西水投集团电子采购平台',
    alias: 'stjt',
    domain: process.env.VUE_APP_STJT_DOMAIN.split(','),
    favicon: './stjt-favicon.ico',
    logo: require('@/assets/images/stjt/logo.png'),
    logoHeight: 58,
    loginLogo: require('@/assets/images/stjt/logo.png'),
    loginBgImg: require('@/assets/images/stjt/background.png'),
    loginContentPosition: 'right',
    needValueAdd: false,
    theme: ['#1890ff', '#ff4d4f'], // 主题颜色 （涉及Element）
    otherTheme: ['#1890ff', '#a7d5ff', '#d8ebff', '#edf6ff', '#f8f9fb'], // 主题衍生色 （不涉及element-ui）
    defaultLoginMethod: 'account',
    loginUrl: process.env.VUE_APP_FZJJT_LOGIN_URL,
    portalUrl: process.env.VUE_APP_FZJJT_PORTAL_URL,
    footer: {
      copyright: '江西水投集团电子采购平台',
      beian: '赣ICP备2021007562号',
      address: '江西省南昌市高新技术开发区紫阳大道3399号云中城A座50-51楼'
    }
  }
]
